import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="not-found-section">
      <div className="not-found-card">
        <h1>404</h1>
        <h2 className="not-found-subheading">Lost in the void</h2>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary">Take me home</Link>
      </div>
    </section>
  );
}
